import * as angular from "angular";
import {UserSessionService} from "./services/user-session/user-session.service";
import {districtService} from "./services/district/district.service";
import {layoutInitService} from "./layout-init/layout-init.service";
import {matchingService} from "./services/matching/matching.service";
import {addressService} from "./services/address/address.service";
import {userService} from "./services/user/user.service";
import {cleverMatchInitService} from "./clever-match-landing/clever-match-init/clever-match-init.service";
import {testImportService} from "./services/test-import/test-import.service";
import {ImportStatusService} from "./services/import-status/import-status.service";
import {tenantConfigurationService} from "./services/tenant-configuration/tenant-configuration.service";
import {staffTestImportService} from "./services/staff-test-import/staff-test-import.service";
import {staffImportRecordsService} from "./services/staff-import-records/staff-import-records.service";
import {configurationService} from "./services/configuration/configuration.service";
import {LinkPathService} from "./link-path/link-path.service";
import {FeatureToggleService} from "./services/feature-toggle/feature-toggle.service";
import { featureFlagService } from "./services/launch-darkly/feature-flag.service";

export function initServices(app: angular.IModule) {
    app.service("userService", userService);
    app.service("userSessionService", UserSessionService);
    app.service("districtService", districtService);
    app.service("layoutInitService", layoutInitService);
    app.service("matchingService", matchingService);
    app.service("addressService", addressService);
    app.service("cleverMatchInitService", cleverMatchInitService);
    app.service("testImportService", testImportService);
    app.service("importStatusService", ImportStatusService);
    app.service("tenantConfigurationService", tenantConfigurationService);
    app.service("staffTestImportService", staffTestImportService);
    app.service("staffImportRecordsService", staffImportRecordsService);
    app.service("configurationService", configurationService);
    app.service("linkPathService", LinkPathService);
    app.service("featureToggleService", FeatureToggleService);
    app.service("featureFlagService", featureFlagService);
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/app.services.ts